/**
 * a wrapper of panwds AccordionPanel to allow customize color of the title portion
 */
import { AccordionPanel as PwdsAccordionPanel } from '@panwds/react-ui'
import { useMemo } from 'react'

import type { AccordionPanelProps } from '@panwds/react-ui'
import type { VFC } from 'react'

import './AccordionPanel.scss'

const AccordionPanel: VFC<AccordionPanelProps> = (props) => {
  const { addClassName: _addClassName, isOpen, ...rest } = props

  const className = useMemo(() => {
    const commonClassName = `${_addClassName} cm-rounded-md cm-border-none`
    return isOpen ? `${commonClassName} ss-accordion-open` : `${commonClassName} ss-accordion-close`
  }, [_addClassName, isOpen])

  return <PwdsAccordionPanel addClassName={className} isOpen={isOpen} {...rest} />
}

export default AccordionPanel
